<template>
  <div class="el-uploader">
    <input
      class="upload-input"
      ref="upload"
      type="file"
      :accept="accept"
      @change="handleChange"
    />
    <el-button icon="el-icon-plus" @click="$refs.upload.click()">
      Choose File
    </el-button>
    <div class="upload-progress">
      <el-progress
        v-if="showProgress"
        :percentage="percentage"
        :status="status"
        :show-text="false"
        :stroke-width="3"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "file-upload",
  props: {
    action: {
      type: String,
      required: true,
    },
    accept: String,
    headers: Object,
    file: Object,
    message: String,
  },
  data() {
    return {
      selectFile: null,
      showProgress: false,
      percentage: 0,
      status: "success",
    };
  },
  methods: {
    reset() {
      this.showProgress = false;
      this.percentage = 0;
      this.status = "success";
    },
    handleChange(e) {
      const file = e.target.files[0];
      this.$refs.upload.value = "";
      if (this.accept) {
        const accept = this.accept.replace(/\./g, "").replace(/,/g, "|");
        const acceptReg = new RegExp(`.(?:${accept})$`, "i");
        if (!acceptReg.test(file.name)) {
          this.$message.warning(
            this.message || `Only ${this.accept}file can be uploaded`
          );
          return;
        }
      }
      this.showProgress = false;
      this.percentage = 0;
      this.status = "success";
      this.selectFile = file;
      if (this.selectFile) {
        let formData = new FormData();
        formData.append("file", this.selectFile, this.selectFile.name);
        this.axios
          .post(this.action, formData, {
            headers: { "Content-Type": "multipart/form-data", ...this.headers },
            onUploadProgress: (e) => {
              if (e.lengthComputable) {
                this.showProgress = true;
                this.percentage = ((e.loaded / e.total) * 100) | 0;
              }
            },
          })
          .then((res) => {
            if (res.code === 200) {
              this.reset();
              this.$emit("success", {
                file: this.selectFile,
                ...res.data,
                // code:'pdf'
              });
            } else {
              this.status = "exception";
              this.$emit("fail", {
                file: this.selectFile,
              });
            }
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-uploader {
  display: inline-flex;
  position: relative;
  .upload-input {
    position: absolute;
    width: 0;
    height: 0;
    opacity: 0;
    cursor: pointer;
    -webkit-appearance: none;
    display: none;
  }
  .upload-progress {
    position: absolute;
    width: 100%;
    bottom: -10px;
    height: 6px;
  }
}
</style>
